module.exports = __webpack_public_path__ + "static/media/romaine lettuce.e7fa73c5.jpg";